import {checkPayment} from "@/api/invoice";

export default {
  watch: {
    orderId: {
      immediate: true,
      handler(id) {
        if (!id) return;

        this.$broadcastClient
          .private(`orders.${id}`)
          .listen('.ConfirmContractProcessingStarted', (e) => {
            this.showAnimateModal();
          })
          .listen('.ConfirmContractProcessingFinished', (e) => {
            this.$alert('ОСЦПВ вдало оформлена!', '');
            this.$router.push({ name: 'history' });
            $('#modalPayAnimation').modal('hide');
          });
      }
    }
  },

  beforeDestroy() {
    if (this.orderId) {
      this.$broadcastClient.leave(`orders.${this.orderId}`);
    }
  }
}
